


































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import QuickInspectionCostComponent from "@/components/QuickInspectionCostComponent.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import QuickInspectListComponent from "@/components/QuickInspectListComponent.vue";
import QuickMitsumoriContentPreview from "@/components/QuickMitsumoriContentPreview.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { QuickMitsumoriQrInfo } from "@/model/quickMitsumoriQrInfo";
import Number from "@/shared/filters/Number.ts";

import * as util from "@/service/util";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CouponData } from "@/model/Coupon";
import { ShakenShohiyou } from "@/model/shakenShohiyou";

import { DO_SEIBI } from "@/model/DoSeibi";
import { SeibiItem } from "@/model/InspectionSeibi";
import { UserService } from "@/service/UserService";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";

import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

@Component({
  components: {
    InputNumber,
    QuickInspectionCostComponent,
    QuickCouponComponent,
    QuickOptionComponent,
    QuickInspectListComponent,
    QuickMitsumoriContentPreview,
    ConfirmDialog
  },
  filters: { Number }
})
export default class QuickMitsumoriContent extends Vue {

  $refs!: {
    quickInspectionCostComponent: QuickInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    saveAndExitDialog: ConfirmDialog;
  };

  listPrefectures: any = {};

  isUserMode = false;
  seibiList: any = [];
  // couponZk: number = 0;
  shouhiyou: any = {
    houteiHiyou: {
      zeiJibaisekiZk: 0,
      zeiWeightTax: 0,
      zeiInshidaiZk: 0,
      zeiTechInfoAmountZk: 0, // 2021-10-12 sh #7458 add
    },
    kensaHiyou: {
      subTotalZk: 0
    },
    shakenHiyou: { subTotalZk: 0 }
  };
  total1 = 0;
  total2 = 0;
  companyInfo: any = {};

  inspectType: number = INSPECT_TYPE.RECOMMEND;

  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogRecommend: boolean = false;
  showDialogPreview: boolean = false;
  showDialogOption: boolean = false;

  preloadingQrInfo: boolean = false;

  public reqService: requestService = new requestService();
  loadingService: loadingService = new loadingService();

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuickFlg: boolean;
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  @Getter("hasData", { namespace: "Shohiyou" })
  hasCostData: boolean;
  @Getter("total", { namespace: "Shohiyou" })
  costDataTotal: any;
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;
  @Getter("total", { namespace: "Coupon" })
  couponData: any;
  @Getter("total", { namespace: "Option" })
  optionData: any;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: QuickMitsumoriQrInfo;

  @Action("setState", { namespace: "QuickMitsumoriQrInfo" })
  setStateQuickMitsumoriQrInfo: any;

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  seibiDataUnSubscribe: any = null;
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

  created() {
    // console.log("QuickMitsumoriContent.created => CALL!!");
    this.isUserMode = this.$route.meta === "user";

    // this.couponZk = this.couponData.subTotalZk;
    this.shouhiyou = this.costData;

    // this.total1 = this.calcTotal1();
    // this.total2 = this.calcTotal2();

    this.getSeibi();

    this.getCompanyInfo();
  }

  getSeibi() {
    // console.log("QuickMitsumoriContent.getSeibi => CALL!!");
    // if (this.hasCostData) {

    // } else {
      const userService = new UserService();
      userService.getAllDataQM();
    // }
    setTimeout(() => {
      this.setListSeibi();
    }, 1000);
  }

  setListSeibi() {
    let seibiList = this.listInspect(this.inspectType);
    // console.log("QuickMitsumoriContent.setListSeibi seibiList => ", seibiList);

    if (seibiList && seibiList.length > 0) {
      let tmpList = util.deepCopy(seibiList);
      let filteredSeibiList = tmpList.filter((item: SeibiItem) => +item.doTenken == DO_SEIBI.suru);
      if ( filteredSeibiList && filteredSeibiList.length > 0) {
        this.seibiList = filteredSeibiList.sort((item1: SeibiItem, item2: SeibiItem) => {
          /** 2021-07-28 sh #6989 add sort for quick mitsumori.(priority 2) [START] */
          if (item1.sknRecommendInspectCategoryId > item2.sknRecommendInspectCategoryId) {
            return 1;
          }
          if (item1.sknRecommendInspectCategoryId < item2.sknRecommendInspectCategoryId) {
            return -1;
          }
          if (item1.sknInspectDescriptionSeibiId > item2.sknInspectDescriptionSeibiId) {
            return 1;
          }
          if (item1.sknInspectDescriptionSeibiId > item2.sknInspectDescriptionSeibiId) {
            return -1;
          }
          /** 2021-07-28 sh #6989 add sort for quick mitsumori.(priority 2) [END] */
          if (item1.sknInspectSeibiId > item2.sknInspectSeibiId) {
            return 1;
          }
          if (item1.sknInspectSeibiId < item2.sknInspectSeibiId) {
            return -1;
          }
          return 0;
        });
      } else {
        this.seibiList = filteredSeibiList;
      }

    }
    // this.showPriceList = util.deepCopy(this.listSeibi);
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  get calcTotal1() {
    return (
      this.shouhiyou.kensaHiyou.subTotalZk +
      this.shouhiyou.houteiHiyou.zeiJibaisekiZk +
      this.shouhiyou.houteiHiyou.zeiWeightTax +
      this.shouhiyou.houteiHiyou.zeiInshidaiZk +
      /** 2021-10-12 sh #7458 implements tech-info-amount. [START] */
      (this.isUseTechInfoAmount ? this.shouhiyou.houteiHiyou.zeiTechInfoAmountZk : 0) +
      /** 2021-10-12 sh #7458 implements tech-info-amount. [END] */
      this.shouhiyou.shakenHiyou.subTotalZk +
      /** 2021-04-08 sh add option [START] */
      // this.optionZk + this.couponZk + this.calcTotal2
      this.optionZk + this.couponZk + this.calcTotal2
      /** 2021-04-08 sh add option [END] */
    );
  }

  get calcTotal2() {
    return this.sumPrice(this.inspectType).totalZk;
  }

  get couponZk() {
    if (!this.couponData) {
      return 0;
    }
    return this.couponData.subTotalZk;
  }

  /** 2021-04-08 sh add option [START] */
  get optionZk() {
    if (!this.optionData) {
      return 0;
    }
    return this.optionData.subTotalZk;
  }
  /** 2021-04-08 sh add option [END] */

  sumItem(item: any) {
    return (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onShowDialogCoupon() {
    this.showDialogCoupon = true;
  }

  onShowDialogRecommend() {
    this.showDialogRecommend = true;
  }

  onCloseDialogInspectionCost() {
    this.$refs.quickInspectionCostComponent.onConfirm();
    this.showDialogInspectionCost = false
    this.getSeibi();
  }

  onCloseDialogCoupon() {
    this.$refs.quickCouponComponent.onConfirm(1);
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.showDialogCoupon = false
    //this.getSeibi();
  }

  onCloseDialogCouponNext() {
    this.showDialogCoupon = false
    this.getSeibi();
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }

  /** 2021-04-08 sh add option [START] */
  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    this.$refs.quickOptionComponent.onConfirm(1);
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.showDialogOption = false
    //this.getSeibi();
  }

  onCloseDialogOptionNext() {
    this.showDialogOption = false
    this.getSeibi();
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }
  /** 2021-04-08 sh add option [END] */

  onCloseDialogRecommend() {
    this.showDialogRecommend = false
    this.getSeibi();
  }

  onUpdateInspectList() {
    this.getSeibi();
  }

  onShowPrintQuickMitsumori() {
    this.showDialogPreview = true;
  }

  /**
   * スクリーンショットを作成して、DBに保存する。
   * スクリーンショットは、URL情報があるQRを読み込めば確認できる
   *
   * 2021-10-11 sh タイミングをズラすために、setTimeoutを使っている。
   */
  onSaveQuickMitsumori() {
    this.loadingService.show();
    /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
    this.$set(this, "preloadingQrInfo", true);
    /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
  
    var node: any = document.getElementById('qm');
 
    setTimeout(()=>{
      htmlToImage.toPng(node).then((dataUrl: any) => {

        this.$set(this, "preloadingQrInfo", false);

        let objQrInfo = {
          ...this.currentStateQuickMitsumoriQrInfo,
          base64QrImage: dataUrl
        }

        this.reqService.saveQuickMitsumoriQrInfo(objQrInfo).then(()=> {
          this.$emit("onUpdateQuickMitsumoriQrInfo");
        });

        this.loadingService.hide();

      }).catch((error: any) => {
        console.error('oops, something went wrong!', error);
        this.$set(this, "preloadingQrInfo", false);
        this.loadingService.hide();
      });
    }, 500);
  }

  /**
   * windowsの印刷機能を利用して、印刷する
   * 2021-10-11 PDF方式に変更
   */
  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
  // onPrintQuickMitsumori() {
  //  window.print();
  // }
  onPrintQuickMitsumori() {
    const id = this.currentStateQuickInfo.sknQuickMitsumoriId;
    this.loadingService.show();
    this.reqService.printQuickMitsumori(id).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = '概算車検見積書.pdf'; // 2021-11-10 sh #7536 change name from 車検見積結果 to 概算車検見積書
      link.click();
    }, (err: any) => {
      this.loadingService.hide();
    });
  }
  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [END] */

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if(res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  onShowConfirmSaveAndExit() {
    this.$refs.saveAndExitDialog.onOpen();
  }

  onConfirmExit() {
    /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [START] */
    // this.$router.push({ name: "reservation" });
    this.$emit("onConfirmExit");
    /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [END] */
  }

  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [START] */
  isCourseSubItem(item: any) {
    if (item && item.rowNum === 0) {
      return "course-sub-item-nm";
    }

    return "";
  }
  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [END] */

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  mounted() {
    this.seibiDataUnSubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'InspectSeibi/setSeibiData') {
        this.setListSeibi();
      }
    });
  }

  beforeDestroy() {
    if (this.seibiDataUnSubscribe) {
      this.seibiDataUnSubscribe();
    }
  }
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

  /** 2021-10-07 sh #7438 implements tech-info-amount for quick estimate preview. [START] */
  get isUseTechInfoAmount() {
    return this.shouhiyou.houteiHiyou.isUseTechInfoAmount == 1;
  }
  /** 2021-10-07 sh #7438 implements tech-info-amount for quick estimate preview. [END] */

}
